var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 4.15803C4.16663 3.34873 4.16663 2.94407 4.33537 2.72101C4.48237 2.52669 4.70706 2.40644 4.95029 2.39192C5.22949 2.37525 5.56618 2.59971 6.23956 3.04863L15.0025 8.89061C15.5589 9.26154 15.8371 9.44701 15.9341 9.68078C16.0188 9.88516 16.0188 10.1149 15.9341 10.3192C15.8371 10.553 15.5589 10.7385 15.0025 11.1094L6.23956 16.9514C5.56618 17.4003 5.22949 17.6248 4.95029 17.6081C4.70706 17.5936 4.48237 17.4733 4.33537 17.279C4.16663 17.0559 4.16663 16.6513 4.16663 15.842V4.15803Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconWhite);
export default __webpack_public_path__ + "static/media/PlayIconWhite.9be2172a295bdfaf49cb8b9bcf3655bb.svg";
export { ForwardRef as ReactComponent };